<template>
    <v-stepper-content step="4">
        <v-form ref="form_lista_documentos">
            <v-container fluid grid-list-md>
                <v-dialog v-model="objDocumentos.abrirModal" persistent :max-width="tamModal" :fullscreen="$root.isTouch">
                    <v-card>
                        <v-card-title class="bg-title-card">
                            <span class="white--text headline" v-html="objDocumentos.titulo"></span>
                        </v-card-title>
                        <v-form ref="form_Modal_documentos">
                            <v-container fluid grid-list-md>
                                <v-row dense>
                                    <v-col cols="12" sm="6">
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-autocomplete label="Documento *" color="textbox" v-model="objDocumentos.idDocumento"
                                                    :items="listGeneral.catalogoDocumentos" item-value="idDocumento"
                                                    :rules="requeridoRegla" item-text="documento" outlined dense/>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-autocomplete label="Firma *" color="textbox" v-model="objDocumentos.idFirma" 
                                                    :items="listGeneral.catalogoFirmas"
                                                    item-value="idFirma" item-text="firma" :rules="requeridoRegla"
                                                    @change="onCargarImagenFirma" outlined dense/>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col cols="12">
                                                <v-autocomplete label="Estado *" color="textbox" v-model="objDocumentos.idEstado" 
                                                    :items="listGeneral.listaEstados"
                                                    item-value="id_estado" item-text="nombre_estado"
                                                    :rules="requeridoRegla" outlined dense/>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="6" v-show="_.size(objDocumentos.firma) > 0">
                                        <div class="text-center">
                                            <img :src="objDocumentos.firma" class="mt-2 img-fluid" style="width:8cm;"/>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="text-right">
                                        <v-btn outlined rounded color="danger" class="mr-1" @click="salir">Salir</v-btn>
                                        <v-btn rounded dark color="primary" @click="guardar">Guardar</v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card>
                </v-dialog>
                <v-row dense>
                    <v-col cols="12" sm="6"/>
                    <v-col cols="12" sm="6">
                        <v-btn rounded dark color="primary" class="float-right" @click="objDocumentos.abrirModal=true;onListarCatalogo()">NUEVO</v-btn>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6"/>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objDocumentos.busqueda" clearable dense prepend-inner-icon="search" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table :search="objDocumentos.busqueda" :headers="listGeneral.cabeceraDocumentos" :items="listaDocumentos" class="elevation-3">
                            <template v-slot:item.accion="{ item }">
                                <v-icon small @click="onEditar(item)">edit</v-icon>
                            </template>

                            <template v-slot:pageText="props">
                                Registro del <span v-text="props.pageStart"></span> al <span
                                    v-text="props.pageStop"></span> de <span v-text="props.itemsLength"></span>
                            </template>

                            <template v-slot:no-results>
                                <v-alert :value="true" color="blue" icon="info" style="height:5%">
                                    Tu búsqueda de "<span v-text="objDocumentos.busqueda"></span>" no arrojó resultados.
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
                <v-row >
                    <v-col class="text-right">
                        <v-btn outlined rounded color="danger" class="mr-1" @click="previous">Anterior</v-btn>
                        <v-btn rounded dark color="primary" @click="validar">Siguiente</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </v-stepper-content>
</template>

<script>
    export default {
        props: ['cargar', 'listGeneral', 'objForm', 'parametros'],
        inject: ['onListar', 'previous', 'next'],
        data() {
            return {
                listaDocumentos: [],
                objDocumentos: {},
            }
        },
        watch: {
            cargar() {
                if (this.cargar && _.size(this.listGeneral.listaDocumentos) == 0) {
                    this.objDocumentos = _.merge({}, _.clone(this.objForm), { titulo: 'Nuevo Documento' });
                    this.cargaGeneral();
                }

                if (_.size(this.listGeneral.listaDocumentos) > 0 && !_.isUndefined(this.objForm.idVehiCredi) && this.objForm.idVehiCredi) { 
                    this.$set(this, 'listaDocumentos', this.listGeneral.listaDocumentos); 
                }
            }
        },
        methods: {
            cargaGeneral() {
                this.onListarDocumentos().catch((e) => {
                    mensajesAlerta(e, 'I');
                })
            },
            onListarCatalogo() {
                var request = [this.onListarCatalogoDocumentos(), this.onListarCatalogoFirmas()];

                Promise.all(request)
                    .then((r) => {
                        if (_.size(this.objDocumentos.path) > 0)
                            this.onCargarImagenFirma();
                    }).catch((e) => {
                        mensajesAlerta(e, 'E')
                    });

            },
            onListarCatalogoDocumentos() {
                return this.onListar(`administrador/producto-documento/listar`, {  'opcion': 'L_COMBO' })
                           .then((respuesta) => {
                                if (_.size(_.get(respuesta,['data','data'],[])) == 0) throw respuesta.data.mensaje;
                                    this.$set(this.listGeneral, 'catalogoDocumentos', respuesta.data.data);
                                return respuesta;
                           });
            },
            onListarCatalogoFirmas() {
                return this.onListar(`administrador/firma/listar`, { opcion: 'L_COMBO' })
                           .then((respuesta) => {
                               if (_.size(_.get(respuesta,['data','data'],[])) == 0) throw respuesta.data.mensaje;
                                    this.$set(this.listGeneral, 'catalogoFirmas', respuesta.data.data);
                               return respuesta;
                           })
            },
            onCargarImagenFirma() {
                var objeto = _.find(this.listGeneral.catalogoFirmas, (v) => { return parseInt(v.idFirma) == parseInt(this.objDocumentos.idFirma) });
                
                return this.onListar('administrador/repository-file/listar', { 'path': objeto.path })
                           .then((respuesta) => {
                               this.$set(this.objDocumentos, 'firma', _.size(respuesta.data.data) ? JSON.parse(JSON.stringify(respuesta.data.data)) : null);
                               this.$forceUpdate();
                           })
                           .catch((e) => {
                               mensajesAlerta(e, 'E');
                           });
            },
            onListarDocumentos() {
                var objeto = {
                    'opcion': 'LISTAR_PRODUCTO_DOCUMENTO',
                    'idProducto': this.objDocumentos.idProducto
                };

                return this.onListar(`administrador/producto-documento/listar`, objeto)
                            .then((respuesta) => {
                                if (_.size(_.get(respuesta,['data','data'],[])) > 0) {

                                    this.$set(this.listGeneral, 'listaDocumentos', respuesta.data.data);

                                    if (_.isUndefined(this.objDocumentos.idVehiCredi) && !this.objDocumentos.idVehiCredi) {
                                        var lista = _.filter(this.listGeneral.listaDocumentos, (o) => {
                                            if (parseInt(o.idDocumento) != this.parametros.idDocCartaReferencia && parseInt(o.idDocumento) != this.parametros.idDocEndosoBeneficiario)
                                                return o;
                                        });
                                        this.$set(this, 'listaDocumentos', lista);
                                    } else
                                        this.$set(this, 'listaDocumentos', this.listGeneral.listaDocumentos);
                                } else
                                    mensajesAlerta(respuesta.data.mensaje, 'E');

                                return respuesta;
                            });
            },
            onEditar(objeto) {
                var index = _.findIndex(this.listaDocumentos, (o) => { return parseInt(o.idDocumento) == parseInt(objeto.idDocumento) });
                var obj = { titulo: 'Editar Documento', index: index, abrirModal: true }

                this.onListarCatalogo();
                this.objDocumentos = _.merge({}, this.objDocumentos, objeto, obj);
            },
            validar() {
                try {
                    if (_.size(this.listaDocumentos) == 0) throw mensajeEstandar.faltaInformación;
                    this.listGeneral.listaDocumentos = _.merge(this.listGeneral.listaDocumentos, this.listaDocumentos);
                    this.next();

                } catch (error) {
                    mensajesAlerta(error, 'I');
                }
            },
            // Modal Documentos - Firmas
            guardar() {
                try {
                    if (!this.$refs.form_Modal_documentos.validate()) throw mensajeEstandar.corregirInformacion;
                    if (_.isUndefined(this.objDocumentos.index)) {
                        if (this._validarInformacion(this.listaDocumentos, this.objDocumentos.index, this.objDocumentos.idDocumento, 'idDocumento')) throw mensajeEstandar.registroExistente;
                    } else {
                        if (this._validarInformacion(this.listaDocumentos, this.objDocumentos.index, this.objDocumentos.idDocumento, 'idDocumento')) throw mensajeEstandar.registroExistente;
                    }

                    var documento = _.find(this.listGeneral.catalogoDocumentos, (o) => { return parseInt(o.idDocumento) == parseInt(this.objDocumentos.idDocumento); });

                    this.objDocumentos.documento = _.size(documento) > 0 ? documento.documento : '';

                    var firma = _.find(this.listGeneral.catalogoFirmas, (o) => { return parseInt(o.idFirma) == parseInt(this.objDocumentos.idFirma) });

                    this.objDocumentos.nombreFirma = _.size(firma) > 0 ? firma.firma : '';

                    var estado = _.find(this.listGeneral.listaEstados, (o) => { return parseInt(o.id_estado) == parseInt(this.objDocumentos.idEstado) });
                    
                    this.objDocumentos.estado = _.size(estado) ? estado.nombre_estado : '';

                    if (_.isUndefined(this.objDocumentos.index))
                        this.listaDocumentos.push(_.omit(this.objDocumentos, ['titulo', 'abrirModal']));
                    else
                        this.listaDocumentos[this.objDocumentos.index] = _.merge(this.listaDocumentos[this.objDocumentos.index], _.omit(this.objDocumentos, ['titulo', 'abrirModal']));

                    this.salir();
                } catch (error) {
                    mensajesAlerta(error, 'I');
                }
            },
            salir() {
                this.$refs.form_Modal_documentos.resetValidation();
                this.objDocumentos = {
                    titulo: 'Nuevo Documento',
                    abrirModal: false,
                    idEstado: '1'
                };
            }
        }
    }
</script>